import { gql } from '@apollo/client';

import { GetUserNotifications } from './__generated__/notifications';

// Shared by every consumer of this query's `userNotifications.notifications` selection --
// centralized here, next to the query that produces it, instead of each consumer re-deriving an
// identical alias.
export type Notification = NonNullable<
  NonNullable<NonNullable<GetUserNotifications>['userNotifications']>['notifications']
>[number];

const GET_NOTIFICATIONS_QUERY = gql`
  query GetUserNotifications {
    userNotifications {
      notifications {
        notificationMetadata {
          userID
          notificationID
          type
          status
          createdAt
          sentAt
          readAt
          content {
            s3Key
            s3Bucket
            s3Version
          }
        }
        content
      }
    }
  }
`;

export { GET_NOTIFICATIONS_QUERY };
